// extracted by mini-css-extract-plugin
export default {"cardContainer":"styles_cardContainer__fdWKv","header":"styles_header__I8v9w","label":"styles_label__gVJ5M","icon":"styles_icon__M-Cax","value":"styles_value__vZX6b"};